import Uploader from './components/uploader.vue';
export default Uploader;
